// src/pages/BlogDetailPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BlogDetail from '../../../components/public/blog/BlogDetail';
import Layout from '../../../components/public/common/Layout';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import { blogService } from '../../../services/blogService';
import { blogInteractionService } from '../../../services/blogInteractionService';

const BlogDetailPage = () => {
  const { urlSlug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBlog = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Check if urlSlug is a valid MongoDB ObjectId
      const isObjectId = /^[0-9a-fA-F]{24}$/.test(urlSlug);
      
      const data = isObjectId 
        ? await blogService.getBlogById(urlSlug)
        : await blogService.getBlogBySlug(urlSlug);  
      
      if (!data) {
        setError('Blog post not found');
        return;
      }
      
      setBlog(data);

      // Track view after successful fetch
      if (data._id) {
        await blogInteractionService.trackView(data._id);
      }
    } catch (error) {
      console.error('Error fetching blog:', error);
      setError(error.message || 'Failed to fetch blog post');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (urlSlug) {
      fetchBlog();
    }
  }, [urlSlug]);

  const handleRetry = () => {
    fetchBlog();
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center min-h-[60vh]">
          <LoadingSpinner />
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="container mx-auto px-6 py-8">
          <div className="text-center">
            <div className="text-red-600 mb-4">{error}</div>
            <div className="space-x-4">
              <button
                onClick={handleRetry}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate('/blog')}
                className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              >
                Back to Blog
              </button>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  if (!blog) {
    return (
      <Layout>
        <div className="container mx-auto px-6 py-8">
          <div className="text-center text-gray-600">
            Blog post not found
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <BlogDetail blog={blog} />
    </Layout>
  );
};

export default BlogDetailPage;
